module.exports = __webpack_public_path__ + "img/7_105.5bfe6c70.png";